export default "__VITE_ASSET__mtwrLkLN__"